export default "__VITE_PUBLIC_ASSET__853ee7ef__"